<template>
  <div class="comp-clip_container" onselectstart="return false">
    <div class="comp-clip-img-list">
      <label v-show="fileList.length < maxLength" class="comp-clip-img-item">
        <input
          class="file-btn"
          type="file"
          :multiple="multiple"
          :disabled="spinning || disabled"
          :accept="accept"
          @change="changeFile"
        />
        <a-spin :spinning="spinning">
          <slot>
            <div class="checked-hit-view">
              <a-icon type="plus" />
              <span v-if="tips"> {{ tips }} </span>
              <div v-else-if="imgW" class="checked-hit-view-text">
                <p>{{ text }}</p>
                <template v-if="!isStrictRestrictions && isClip">
                  <p v-if="imgH">
                    上传({{ imgW * 1 }}px*{{ imgH * 1 }}px)等比例的图片
                  </p>
                  <p v-else>(宽度最小{{ imgW }}px*高度自适应)</p>
                </template>
                <template v-if="!isClip && !isStrictRestrictions">
                  <p v-if="imgH && imgW">
                    建议上传({{ imgW }}px*{{ imgH }}px)的图片
                  </p>
                  <p v-else-if="imgW">建议上传宽度({{ imgW }}px的图片)</p>
                  <p v-else-if="imgH">建议上传高度({{ imgH }}px的图片)</p>
                </template>
                <template v-else-if="isStrictRestrictions && imgW && imgH">
                  <p v-if="imgH">严格上传({{ imgW }}px*{{ imgH }}px)的图片</p>
                </template>
              </div>
              <div v-else>上传任意尺寸的图片，请慎重。</div>
            </div>
          </slot>
        </a-spin>
      </label>
      <vue-draggable
        v-model="fileList"
        class="draggable-list"
        :disabled="isDrag || spinning"
        @update="$emit('draggableUpdate')"
      >
        <div
          v-for="(item, i) in fileList.slice(0, maxLength)"
          :key="item.url + i + ''"
          class="img-box comp-clip-img-item"
        >
          <div class="img-cover">
            <a-icon
              type="eye"
              style="margin-right:10px"
              @click="handleImgView(i)"
            />
            <a-popconfirm
              title="确认删除？"
              ok-text="是"
              cancel-text="否"
              @confirm="handleImgDel(i)"
            >
              <a-icon type="rest" />
            </a-popconfirm>
          </div>
          <img :src="item.url" class="img-element" alt="" />
        </div>
      </vue-draggable>
    </div>
    <!-- 图片裁剪 -->
    <a-modal
      :visible.sync="showClipPopup"
      onselectstart="return false"
      class="clip-dialog"
      top="5vh"
      :get-container="() => $el"
      width="800px"
      @opened="handleOpen"
    >
      <slot slot="title" name="title">
        <div class="clip-header">
          <div class="el-dialog__title">
            {{ !setMosaicIng ? title || '图片裁剪' : '添加马赛克' }}
          </div>
          <span
            v-show="!setMosaicIng && isNeedMosaic"
            size="small"
            class="add-mosaic-btn"
            @click="handleMosaicInit"
          >
            添加马赛克
          </span>
          <div
            v-if="showReset && !setMosaicIng"
            class="control-reset"
            @click="handleOpenFile"
          >
            重新上传
          </div>
        </div>
      </slot>
      <div
        v-show="!setMosaicIng"
        class="clip-box_content"
        ondragstart="return false"
      >
        <div class="clip-box_content-img">
          <img
            :src="imgStr"
            class="clip-img"
            style="max-width: 100%; max-height: 100%"
          />
        </div>

        <div :style="{ opacity: showCover ? 1 : 0 }" class="clip-content-wrap">
          <div class="shade_lef shade_pop"></div>
          <div class="shade_right shade_pop"></div>
          <div class="shade_top shade_pop"></div>
          <div class="shade_bottom shade_pop"></div>
          <div
            class="center"
            :style="{
              width: getCoverStyle.W + 'px',
              height: getCoverStyle.H + 'px',
              left: getCoverStyle.X + 'px',
              top: getCoverStyle.Y + 'px'
            }"
          >
            <div class="center_box">
              <div v-if="!fixedSize" class="center_control"></div>
            </div>
          </div>
        </div>
      </div>
      <div v-show="setMosaicIng" class="mosaic-box">
        <ul class="mosaic-icon-list">
          <li
            v-for="(item, i) in Object.keys(mosaicIcon)"
            :key="i"
            :class="{
              current:
                currentMosaic.id && currentMosaic.id === mosaicIcon[item].id
            }"
            class="mosaic-icon-item"
          >
            <img
              :id="mosaicIcon[item].id"
              :src="mosaicIcon[item].url"
              :alt="mosaicIcon[item].name"
              :title="mosaicIcon[item].name"
              @click="currentMosaic = mosaicIcon[item]"
            />
          </li>
          <li
            :class="[
              'mosaic-icon-item',
              'mosaicicon',
              'icon-chexiao',
              'control-log'
            ]"
            :style="{ color: allMosaicList.length ? '#000' : '#ccc' }"
            @click="handleDelMosaic"
          ></li>
          <li
            :class="[
              'mosaic-icon-item',
              'mosaicicon',
              'icon-chongzuo',
              'control-log'
            ]"
            :style="{ color: recoverMosaicList.length ? '#000' : '#ccc' }"
            @click="recoverMosaicLog"
          ></li>
        </ul>
        <div class="mosaic-canvas-box"></div>
      </div>
      <div slot="footer" class="clip-control">
        <a-button type="primary" @click="DrawAndDown">
          确 定
        </a-button>
        <a-button
          @click="
            setMosaicIng ? (setMosaicIng = false) : (showClipPopup = false)
          "
        >
          取消
        </a-button>
      </div>
    </a-modal>

    <div
      v-show="viewImageIng"
      class="show-img-origin-list-cover"
      @click="viewImageIng = false"
    ></div>
    <div v-show="viewImageIng" class="show-img-origin-box">
      <div class="show-img-origin-box-content">
        <div
          v-show="fileList.slice(0, maxLength).length > 1"
          class="control-toggle-left"
          @click="handleViewIndex(-1)"
        >
          <a-icon type="left" />
        </div>
        <div
          v-show="fileList.slice(0, maxLength).length > 1"
          class="control-toggle-right"
          @click="handleViewIndex(1)"
        >
          <a-icon type="right" />
        </div>
        <div class="close-img-origin-list" @click="viewImageIng = false">
          <a-icon type="close" />
        </div>
        <div class="show-imgs">
          <template v-for="(item, i) in fileList.slice(0, maxLength)">
            <img
              v-show="i === viewIndex"
              :key="i"
              :style="{ opacity: i === viewIndex ? 1 : 0 }"
              :src="item.url"
            />
          </template>
        </div>
      </div>
    </div>

    <p v-for="(size, index) in fileSizes" :key="index" class="tips">
      图片{{ index + 1 }}大小为
      <span> {{ size.transformSize }} </span>
      <template v-if="size.originSize >= 100000">
        ，
        <span class="bold">
          已超出100KB，建议优化图片大小后重新上传
        </span>
      </template>
    </p>
  </div>
</template>

<script>
import index from './lib'
export default index
</script>

<style lang="less">
@import './lib/index.less';
</style>
